import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-29656-Educator-HS-Simplification'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
